import React from "react";
import { SectionHeader } from "@/sections/Services";

const STEPS = [
  {
    n: "01",
    title: "Discover",
    copy: "We understand your business, users, goals and current workflows.",
  },
  {
    n: "02",
    title: "Plan",
    copy: "We map the product structure, features, user journeys and technical approach.",
  },
  {
    n: "03",
    title: "Design",
    copy: "We create a premium, practical interface that feels modern and easy to use.",
  },
  {
    n: "04",
    title: "Build",
    copy: "We develop the website, app or system with clean structure and scalable foundations.",
  },
  {
    n: "05",
    title: "Launch & Improve",
    copy: "We help move from launch to iteration, improvement and long-term value.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32 border-t border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <SectionHeader
          eyebrow="Process"
          title="How we work"
          subtitle="Our approach is structured, practical and focused on delivering outcomes — not just completing tasks."
        />

        {/* Desktop: horizontal timeline */}
        <div className="hidden md:block mt-20 relative">
          <div className="absolute top-[26px] left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" aria-hidden />
          <div className="grid grid-cols-5 gap-6 relative">
            {STEPS.map((s, i) => (
              <div
                key={s.n}
                className="mk-reveal flex flex-col items-start"
                style={{ transitionDelay: `${i * 100}ms` }}
                data-testid={`process-step-${i}`}
              >
                <div className="relative">
                  <div className="h-[52px] w-[52px] rounded-full border border-white/15 bg-[#07111F] flex items-center justify-center font-mono text-[13px] text-[#00D4FF] mk-pulse">
                    {s.n}
                  </div>
                </div>
                <h3 className="mt-7 font-display text-xl text-white tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-[14px] text-slate-400 leading-relaxed">
                  {s.copy}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile: stacked */}
        <div className="md:hidden mt-14 relative pl-6 space-y-7 border-l border-white/10">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              className="mk-reveal relative"
              style={{ transitionDelay: `${i * 80}ms` }}
              data-testid={`process-step-mobile-${i}`}
            >
              <div className="absolute -left-[33px] top-1 h-4 w-4 rounded-full bg-[#07111F] border-2 border-[#00D4FF]" />
              <div className="font-mono text-[11px] tracking-widest text-[#00D4FF]">
                {s.n}
              </div>
              <h3 className="mt-1 font-display text-lg text-white tracking-tight">
                {s.title}
              </h3>
              <p className="mt-1.5 text-[14px] text-slate-400 leading-relaxed">
                {s.copy}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
